const LIST_COLOR = {
    grey: '#778899',
    black: '#000000',
    pink: '#ff6b81',
    red: '#ff0000',
    blue: '#0000cd',
    green: '#32cd32',
    orange: '#ff4500',
    violet: '#800080',
    brown: '#cd853f',
    redBrick: '#9f0000'
};

export const LIST_SUPPORT_ATTACH_FILE = {
    EXT_FILE_PAGE_KNOWLEDGE: {
        DISPLAY: 'page',
        LIST: [],
        COLOR_DISPLAY: LIST_COLOR.redBrick
    },
    EXT_FILE_OTHER: {
        DISPLAY: 'others',
        LIST: ['others'],
        COLOR_DISPLAY: LIST_COLOR.black
    },
    EXT_FILE_TXT: {
        DISPLAY: 'txt',
        LIST: ['txt'],
        COLOR_DISPLAY: LIST_COLOR.grey
    },
    EXT_FILE_ZIP: {
        DISPLAY: 'zip',
        LIST: ['zip'],
        COLOR_DISPLAY: LIST_COLOR.brown
    },
    EXT_FILE_PDF: {
        DISPLAY: 'pdf',
        LIST: ['pdf'],
        COLOR_DISPLAY: LIST_COLOR.red
    },
    EXT_FILE_HTML: {
        DISPLAY: 'html',
        LIST: ['html', 'htm'],
        COLOR_DISPLAY: LIST_COLOR.black
    },
    EXT_FILE_IMAGE: {
        DISPLAY: 'image',
        LIST: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'tif', 'tiff', 'webp'],
        COLOR_DISPLAY: LIST_COLOR.pink
    },
    EXT_FILE_DOC: {
        DISPLAY: 'doc',
        LIST: ['doc', 'docx', 'docm'],
        COLOR_DISPLAY: LIST_COLOR.blue
    },
    EXT_FILE_XLS: {
        DISPLAY: 'xls',
        LIST: ['xls', 'xlsx', 'xlsm', 'csv'],
        COLOR_DISPLAY: LIST_COLOR.green
    },
    EXT_FILE_PPT: {
        DISPLAY: 'ppt',
        LIST: ['ppt', 'pptx', 'pptm'],
        COLOR_DISPLAY: LIST_COLOR.orange
    },
    EXT_FILE_VIDEO: {
        DISPLAY: 'video',
        LIST: ['mov', 'avi', 'mpeg', 'mp4', 'wmv', 'flv'],
        COLOR_DISPLAY: LIST_COLOR.violet
    },
    EXT_FILE_AUDIO: {
        DISPLAY: 'audio',
        LIST: ['wav', 'm4a', 'm4p', 'dsf', 'flac', 'mqa', 'mp3'],
        COLOR_DISPLAY: LIST_COLOR.black
    },
    EXT_FILE_AUTOCAD: {
        DISPLAY: 'AutoCAD',
        LIST: ['dxf', 'dwg', 'igs'],
        COLOR_DISPLAY: LIST_COLOR.black
    }
};

/**
 * Get file type info from extension
 * @param {string} fileExtension - File extension (e.g., 'pdf', 'jpg', 'docx')
 * @returns {{ DISPLAY: string, COLOR_DISPLAY: string }}
 */
const getFileTypeInfo = (extension) => {
    if (!extension) {
        return LIST_SUPPORT_ATTACH_FILE.EXT_FILE_OTHER;
    }

    const ext = extension.toLowerCase().replace('.', '');

    // Search in all file types
    const found = Object.values(LIST_SUPPORT_ATTACH_FILE).find((item) =>
        item.LIST && item.LIST.includes(ext)
    );

    return found || LIST_SUPPORT_ATTACH_FILE.EXT_FILE_OTHER;
};

function AttachFileIcon({ width = 56, height = 40, extension = 'others', background = '#FAF9F1' }) {
    const fileInfo = getFileTypeInfo(extension);
    const displayColor = fileInfo.COLOR_DISPLAY;
    const displayText = fileInfo.DISPLAY;

    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 56 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="56" height="40" fill={background} />
            <path
                d="M5.112 37L7.296 31.4H7.944L10.128 37H9.304L8.768 35.568H6.456L5.92 37H5.112ZM6.704 34.88H8.52L7.624 32.448L6.704 34.88ZM11.8376 37.088C11.475 37.088 11.2003 37.0187 11.0136 36.88C10.827 36.736 10.7336 36.464 10.7336 36.064V33.784H9.95763V33.16H10.7336V31.784H11.4456V33.16H12.5576V33.784H11.4456V35.912C11.4456 36.12 11.491 36.2613 11.5816 36.336C11.6776 36.4053 11.819 36.44 12.0056 36.44C12.1016 36.44 12.2003 36.4267 12.3016 36.4C12.4083 36.368 12.4936 36.336 12.5576 36.304V36.968C12.4723 37.0053 12.363 37.0347 12.2296 37.056C12.0963 37.0773 11.9656 37.088 11.8376 37.088ZM14.8845 37.088C14.5218 37.088 14.2472 37.0187 14.0605 36.88C13.8738 36.736 13.7805 36.464 13.7805 36.064V33.784H13.0045V33.16H13.7805V31.784H14.4925V33.16H15.6045V33.784H14.4925V35.912C14.4925 36.12 14.5378 36.2613 14.6285 36.336C14.7245 36.4053 14.8658 36.44 15.0525 36.44C15.1485 36.44 15.2472 36.4267 15.3485 36.4C15.4552 36.368 15.5405 36.336 15.6045 36.304V36.968C15.5192 37.0053 15.4098 37.0347 15.2765 37.056C15.1432 37.0773 15.0125 37.088 14.8845 37.088ZM17.5474 37.064C17.158 37.0747 16.8354 36.9867 16.5794 36.8C16.3287 36.608 16.2034 36.3333 16.2034 35.976C16.2034 35.7147 16.286 35.488 16.4514 35.296C16.622 35.104 16.838 34.9547 17.0994 34.848C17.366 34.736 17.6407 34.68 17.9234 34.68C18.0887 34.6693 18.2407 34.6853 18.3794 34.728C18.518 34.7653 18.638 34.8213 18.7394 34.896V34.416C18.7394 34.1173 18.6754 33.9227 18.5474 33.832C18.4247 33.7413 18.2327 33.696 17.9714 33.696C17.7474 33.696 17.5074 33.736 17.2514 33.816C17.0007 33.896 16.7874 33.9973 16.6114 34.12L16.2754 33.56C16.494 33.4213 16.7527 33.304 17.0514 33.208C17.3554 33.112 17.662 33.064 17.9714 33.064C18.462 33.064 18.8274 33.1627 19.0674 33.36C19.3074 33.552 19.4274 33.904 19.4274 34.416V36.344C19.4274 36.4453 19.454 36.504 19.5074 36.52C19.5607 36.536 19.6807 36.5227 19.8674 36.48V36.944C19.798 36.9707 19.71 36.9973 19.6034 37.024C19.4967 37.0507 19.3874 37.064 19.2754 37.064C19.1047 37.064 18.982 37.032 18.9074 36.968C18.8327 36.904 18.782 36.7893 18.7554 36.624C18.6114 36.768 18.43 36.8747 18.2114 36.944C17.9927 37.0133 17.7714 37.0533 17.5474 37.064ZM17.5554 36.432C17.7794 36.4267 17.982 36.3947 18.1634 36.336C18.35 36.272 18.4967 36.184 18.6034 36.072C18.71 35.9547 18.758 35.816 18.7474 35.656C18.7367 35.5067 18.6594 35.4 18.5154 35.336C18.3767 35.272 18.198 35.2453 17.9794 35.256C17.782 35.2613 17.6007 35.2987 17.4354 35.368C17.27 35.432 17.1367 35.5173 17.0354 35.624C16.9394 35.7307 16.8914 35.8507 16.8914 35.984C16.8967 36.1333 16.958 36.248 17.0754 36.328C17.1927 36.4027 17.3527 36.4373 17.5554 36.432ZM22.1364 37.088C21.7844 37.088 21.4697 37.0053 21.1924 36.84C20.9204 36.6693 20.7044 36.4347 20.5444 36.136C20.3897 35.832 20.3124 35.48 20.3124 35.08C20.3124 34.68 20.3897 34.328 20.5444 34.024C20.7044 33.72 20.9204 33.4853 21.1924 33.32C21.4697 33.1493 21.7844 33.064 22.1364 33.064C22.4297 33.064 22.699 33.1253 22.9444 33.248C23.1897 33.3653 23.395 33.5387 23.5604 33.768L22.9924 34.192C22.795 33.8773 22.5097 33.72 22.1364 33.72C21.811 33.72 21.5444 33.84 21.3364 34.08C21.1337 34.32 21.0324 34.6533 21.0324 35.08C21.0324 35.5013 21.1337 35.832 21.3364 36.072C21.5444 36.312 21.811 36.432 22.1364 36.432C22.5097 36.432 22.7977 36.2773 23.0004 35.968L23.5604 36.384C23.395 36.6133 23.1897 36.7893 22.9444 36.912C22.699 37.0293 22.4297 37.088 22.1364 37.088ZM24.4266 37V31.264H25.1466V33.656C25.2426 33.496 25.384 33.3573 25.5706 33.24C25.7573 33.1227 25.9733 33.064 26.2186 33.064C26.624 33.064 26.952 33.1947 27.2026 33.456C27.4586 33.712 27.5866 34.0853 27.5866 34.576V37H26.8746V34.728C26.8746 34.392 26.8 34.1413 26.6506 33.976C26.5013 33.8053 26.3066 33.72 26.0666 33.72C25.7946 33.72 25.5733 33.8107 25.4026 33.992C25.232 34.168 25.1466 34.4053 25.1466 34.704V37H24.4266ZM30.3008 37.088C29.9381 37.088 29.6181 37.0107 29.3408 36.856C29.0635 36.7013 28.8475 36.4747 28.6928 36.176C28.5381 35.872 28.4608 35.5067 28.4608 35.08C28.4608 34.6693 28.5381 34.3147 28.6928 34.016C28.8475 33.712 29.0581 33.4773 29.3248 33.312C29.5968 33.1467 29.9088 33.064 30.2608 33.064C30.6128 33.064 30.9115 33.152 31.1568 33.328C31.4075 33.4987 31.5968 33.728 31.7248 34.016C31.8581 34.304 31.9248 34.6187 31.9248 34.96V35.152H29.1648C29.1755 35.5787 29.2821 35.904 29.4848 36.128C29.6928 36.3467 29.9675 36.456 30.3088 36.456C30.5808 36.456 30.8048 36.3893 30.9808 36.256C31.1621 36.1227 31.3141 35.9227 31.4368 35.656L31.9808 36.016C31.7995 36.3893 31.5675 36.6613 31.2848 36.832C31.0075 37.0027 30.6795 37.088 30.3008 37.088ZM29.2048 34.576H31.2208C31.1781 34.2987 31.0715 34.0747 30.9008 33.904C30.7301 33.7333 30.5141 33.648 30.2528 33.648C29.9755 33.648 29.7461 33.728 29.5648 33.888C29.3835 34.0427 29.2635 34.272 29.2048 34.576ZM34.4645 37.088C34.1125 37.088 33.7978 37.008 33.5205 36.848C33.2485 36.6827 33.0325 36.4507 32.8725 36.152C32.7178 35.848 32.6405 35.4907 32.6405 35.08C32.6405 34.664 32.7178 34.3067 32.8725 34.008C33.0325 33.704 33.2485 33.472 33.5205 33.312C33.7978 33.1467 34.1125 33.064 34.4645 33.064C34.6992 33.064 34.9125 33.1147 35.1045 33.216C35.3018 33.3173 35.4672 33.4613 35.6005 33.648V31.264H36.3125V37H35.6805L35.6565 36.448C35.5232 36.6453 35.3525 36.8027 35.1445 36.92C34.9418 37.032 34.7152 37.088 34.4645 37.088ZM34.4885 36.432C34.8138 36.432 35.0805 36.312 35.2885 36.072C35.5018 35.832 35.6085 35.5013 35.6085 35.08C35.6085 34.6533 35.5018 34.32 35.2885 34.08C35.0805 33.84 34.8138 33.72 34.4885 33.72C34.1632 33.72 33.8938 33.84 33.6805 34.08C33.4672 34.32 33.3605 34.6533 33.3605 35.08C33.3605 35.5013 33.4672 35.832 33.6805 36.072C33.8938 36.312 34.1632 36.432 34.4885 36.432ZM39.7098 37V31.4H43.3738V32.088H40.4378V33.792H43.1258V34.488H40.4378V37H39.7098ZM44.2265 37V33.16H44.9385V37H44.2265ZM44.5785 32.44C44.4452 32.44 44.3305 32.3947 44.2345 32.304C44.1438 32.208 44.0985 32.0933 44.0985 31.96C44.0985 31.8267 44.1438 31.7147 44.2345 31.624C44.3305 31.528 44.4452 31.48 44.5785 31.48C44.7065 31.48 44.8158 31.528 44.9065 31.624C45.0025 31.7147 45.0505 31.8267 45.0505 31.96C45.0505 32.0933 45.0025 32.208 44.9065 32.304C44.8158 32.3947 44.7065 32.44 44.5785 32.44ZM46.1298 37V31.264H46.8498V37H46.1298ZM49.5508 37.088C49.1881 37.088 48.8681 37.0107 48.5908 36.856C48.3135 36.7013 48.0975 36.4747 47.9428 36.176C47.7881 35.872 47.7108 35.5067 47.7108 35.08C47.7108 34.6693 47.7881 34.3147 47.9428 34.016C48.0975 33.712 48.3081 33.4773 48.5748 33.312C48.8468 33.1467 49.1588 33.064 49.5108 33.064C49.8628 33.064 50.1615 33.152 50.4068 33.328C50.6575 33.4987 50.8468 33.728 50.9748 34.016C51.1081 34.304 51.1748 34.6187 51.1748 34.96V35.152H48.4148C48.4255 35.5787 48.5321 35.904 48.7348 36.128C48.9428 36.3467 49.2175 36.456 49.5588 36.456C49.8308 36.456 50.0548 36.3893 50.2308 36.256C50.4121 36.1227 50.5641 35.9227 50.6868 35.656L51.2308 36.016C51.0495 36.3893 50.8175 36.6613 50.5348 36.832C50.2575 37.0027 49.9295 37.088 49.5508 37.088ZM48.4548 34.576H50.4708C50.4281 34.2987 50.3215 34.0747 50.1508 33.904C49.9801 33.7333 49.7641 33.648 49.5028 33.648C49.2255 33.648 48.9961 33.728 48.8148 33.888C48.6335 34.0427 48.5135 34.272 48.4548 34.576Z"
                fill="#8E8C8C"
            />
            <rect x="30.7261" y="15.5811" width="17.4275" height="12.4189" fill="#D9D9D9" />
            <g filter="url(#filter0_d_31671_63330)">
                <mask id="path-4-inside-1_31671_63330" fill="white">
                    <path d="M30 14.8911H47.4275V27.31H30V14.8911Z" />
                </mask>
                <path d="M30 14.8911H47.4275V27.31H30V14.8911Z" fill="#FEFEFE" />
                <path
                    d="M47.4275 27.31V27.51H47.6275V27.31H47.4275ZM30 27.31H29.8V27.51H30V27.31ZM47.4275 14.8911H47.2275V27.31H47.4275H47.6275V14.8911H47.4275ZM47.4275 27.31V27.11H30V27.31V27.51H47.4275V27.31ZM30 27.31H30.2V14.8911H30H29.8V27.31H30Z"
                    fill="#B2B2B2"
                    mask="url(#path-4-inside-1_31671_63330)"
                />
            </g>
            <line
                y1="-0.1"
                x2="8.01321"
                y2="-0.1"
                transform="matrix(0.72495 0.688801 -0.72495 0.688801 41.6183 9.37158)"
                stroke="#B2B2B2"
                strokeWidth="0.2"
            />
            <path
                d="M38.0455 18.4101L41.7516 9.49094L47.4328 14.8889L38.0455 18.4101Z"
                fill="white"
            />
            <line
                x1="47.4276"
                y1="14.9911"
                x2="41.6184"
                y2="14.9911"
                stroke="#B2B2B2"
                strokeWidth="0.2"
            />
            <line
                x1="41.7183"
                y1="9.37158"
                x2="41.7183"
                y2="14.8911"
                stroke="#B2B2B2"
                strokeWidth="0.2"
            />
            <mask id="path-10-inside-2_31671_63330" fill="white">
                <path d="M30 9.3717H41.6184V27.3101H30V9.3717Z" />
            </mask>
            <path d="M30 9.3717H41.6184V27.3101H30V9.3717Z" fill="#FEFEFE" />
            <path
                d="M30 9.3717V9.1717H29.8V9.3717H30ZM30 27.3101H29.8V27.5101H30V27.3101ZM30 9.3717V9.5717H41.6184V9.3717V9.1717H30V9.3717ZM41.6184 27.3101V27.1101H30V27.3101V27.5101H41.6184V27.3101ZM30 27.3101H30.2V9.3717H30H29.8V27.3101H30Z"
                fill="#B2B2B2"
                mask="url(#path-10-inside-2_31671_63330)"
            />
            <line x1="32" y1="17.75" x2="45" y2="17.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <line x1="32" y1="19.75" x2="45" y2="19.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <line x1="32" y1="21.75" x2="45" y2="21.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <line x1="32" y1="23.75" x2="45" y2="23.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <path
                d="M45.803 9.83254L45.0418 9.07204L41.2355 12.8775C41.0856 13.0275 40.9667 13.2055 40.8856 13.4014C40.8045 13.5973 40.7628 13.8073 40.7628 14.0193C40.7628 14.2313 40.8046 14.4413 40.8858 14.6372C40.967 14.833 41.0859 15.011 41.2359 15.1609C41.3858 15.3108 41.5638 15.4297 41.7597 15.5108C41.9557 15.5919 42.1656 15.6337 42.3776 15.6336C42.5897 15.6336 42.7996 15.5918 42.9955 15.5106C43.1914 15.4295 43.3694 15.3105 43.5193 15.1605L48.0868 10.5938C48.5914 10.089 48.8749 9.40451 48.8748 8.69077C48.8747 7.97703 48.5911 7.29255 48.0864 6.78791C47.5816 6.28327 46.8971 5.99981 46.1834 5.99988C45.4696 5.99995 44.7851 6.28355 44.2805 6.78829L39.485 11.583L39.4745 11.5928C38.0083 13.059 38.0083 15.435 39.4745 16.9005C40.9408 18.366 43.3168 18.366 44.783 16.9005L44.7928 16.89L44.7935 16.8908L48.0673 13.6178L47.306 12.8573L44.0323 16.1295L44.0225 16.1393C43.5201 16.6407 42.8393 16.9223 42.1295 16.9223C41.4197 16.9223 40.7389 16.6407 40.2365 16.1393C39.9873 15.8898 39.7898 15.5936 39.6554 15.2676C39.521 14.9416 39.4523 14.5922 39.4533 14.2396C39.4543 13.887 39.5249 13.538 39.6611 13.2128C39.7973 12.8875 39.9964 12.5924 40.247 12.3443L40.2463 12.3435L45.0425 7.54879C45.6718 6.91879 46.6963 6.91879 47.3263 7.54879C47.9563 8.17879 47.9555 9.20254 47.3263 9.83179L42.7588 14.3985C42.6565 14.4926 42.5219 14.5435 42.3831 14.5406C42.2442 14.5377 42.1119 14.4813 42.0136 14.3832C41.9154 14.285 41.8588 14.1527 41.8558 14.0138C41.8528 13.875 41.9036 13.7403 41.9975 13.638L45.8038 9.83179L45.803 9.83254Z"
                fill="#888888"
            />
            <path d="M0 0H24V6C24 8.76142 21.7614 11 19 11H0V0Z" fill={displayColor} />
            <text
                x="12"
                y="7"
                fill="#FFFFFF"
                fontSize="10"
                fontWeight="bold"
                textAnchor="middle"
                dominantBaseline="middle"
            >
                {displayText}
            </text>
            <line x1="32" y1="11.75" x2="40" y2="11.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <line x1="32" y1="13.75" x2="40" y2="13.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <line x1="32" y1="15.75" x2="40" y2="15.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <line x1="32" y1="25.75" x2="45" y2="25.75" stroke="#B2B2B2" strokeWidth="0.5" />
            <rect x="31.9001" y="20.5819" width="4.41813" height="4.41813" fill="#FF8EAB" />
            <circle cx="37.4228" cy="22.4228" r="2.57724" fill="#FEFE95" />
            <path d="M35.5818 17.6365L38.1326 22.0546H33.031L35.5818 17.6365Z" fill="#8EABFF" />
            <defs>
                <filter
                    id="filter0_d_31671_63330"
                    x="26"
                    y="10.8911"
                    width="25.4276"
                    height="20.4189"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_31671_63330"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_31671_63330"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}

export default AttachFileIcon;
